import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppInterceptorService } from './shared/services/app-interceptor/app-interceptor.service';
import { SharedModule } from './shared/modules/shared.module';
import { environment } from 'src/environments/environment';
import { ENVIRONMENT as ANALYTICS_ENV } from 'verben-analytics-ui';
import { EncryptionService } from './core/services/encryption.service';
// import { provideUserIdleConfig } from 'angular-user-idle';
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

function initializeApp(encryptor: EncryptionService): () => Promise<any> {
  return encryptor.setEnumerator.bind(encryptor);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    // NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorService,
      multi: true,
    },
    {
      provide: ANALYTICS_ENV,
      useValue: {
        production: environment.production,
        BaseUrl: environment.BASE_URL
        //TenantKey: environment.TenantKey,
        // Tenant: environment.Tenant,
        // APIKey: environment.APIKey,
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [EncryptionService],
      multi: true,
    },
    // provideUserIdleConfig({ idle: 300 })
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
